import React, { useEffect, useState } from "react";
import { SiAirplayaudio } from "react-icons/si";
import { Link } from "react-router-dom";
import {
  CardText,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { getNextEpisode } from "@store/action/planning/EpisodeAction";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { useDispatch, useSelector } from "react-redux";
import { getWebsiteStyle } from "@store/action/smartend/SettingsAction";
import { Clock } from "react-feather";
import { useTranslation } from "react-i18next";
import { getBanner } from "@store/action/smartend/BannerAction";
import { _getAllQuizz } from "@src/redux/action/quizz/QuizzAction";
import { getMenus } from "@store/action/smartend/MenuAction";
import IntlDropdown from "../../@core/layouts/components/navbar/IntlDropdown";
import GroupChat from "@src/@core/components/customizer/GroupChat";
import classNames from "classnames";
import WidgetsFloatingMenu from "./home/widgetsFloatingMenu/WidgetsFloatingMenu";
import Janus from "janus-gateway";
import adapter from "webrtc-adapter";
import { useIcecast } from "@hooks/useIcecast";

const REACT_APP_JANUS_SERVER = process.env.REACT_APP_JANUS_SERVER;

const Navbar = ({
  playerPause,
  isPaused,
  isloadind,
  setIsloadind,
  RadioReducer,
}) => {
  const { icecastData, host } = useIcecast();
  const onAir =
    icecastData?.artist === "live" && icecastData?.title.startsWith(host);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const radio_id = localStorage.getItem("radio_id");
  const thisisAuth = localStorage.getItem("isAuth");
  const music_icecast = RadioReducer?.single?.icecast_url_streaming;
  const music_hls = RadioReducer?.single?.hls_url_streaming;
  const tuneIn_player = document.getElementById("tuneIn_player");
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const [toggleThreeBars, setToggleThreeBars] = useState(false);
  const [timeNow, setValue] = useState(new Date());

  const url = window.location.pathname;
  const [active, setActive] = useState(url);
  const SettingsReducer = useSelector((state) => state.SettingsReducer).data;
  const MenuReducer = useSelector((state) => state.MenuReducer).data;

  const toggleActive = (tab) => {
    if (active !== tab) {
      setActive(tab);
    }
  };
  const data = {
    currentsong: music_hls ? music_hls : music_icecast,
    downoladUrl: null,
    namesong: null,
    songimg: null,
    playlist: [],
    item_data: null,
    is_web_rtc: true,
  };
  const playAudio = () => {
    if (!isloadind) {
      dispatch(addMusic(data));
      const playPromise = tuneIn_player.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {}).catch((error) => {});
      }
      setIsloadind(true);
      setLive_btn_clicked(true);
    } else {
      return;
    }
  };
  const stopAudio = () => {
    dispatch(
      addMusic({
        downoladUrl: null,
        namesong: null,
        songimg: null,
        playlist: [],
      })
    );
    isPaused();
    setLive_btn_clicked(false);
    tuneIn_player.pause();
  };
  const listeners = icecastData?.listeners | 0;
  const goTop = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    setActive(url);
  }, [url]);
  useEffect(() => {
    dispatch(getBanner({ per_page: 1000 }));
    dispatch(getNextEpisode());
    dispatch(getWebsiteStyle());
    _getAllQuizz(5, 1, dispatch);
  }, [dispatch]);
  useEffect(() => {
    const interval = setInterval(() => setValue(new Date()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const [live_btn_clicked, setLive_btn_clicked] = useState(false);
  const [curentObjSrc, setCurentObjSrc] = useState(null);

  useEffect(() => {
    var videoPreview = document.getElementById("video-preview");
    var tuneIn_player = document.getElementById("tuneIn_player");
    if (live_btn_clicked && onAir) {
      videoPreview.srcObject = curentObjSrc;
      const playPromise = videoPreview?.play();
      if (playPromise != undefined) {
        playPromise.then((_) => {}).catch((error) => {});
      }
      videoPreview.hidden = false;
    } else {
      videoPreview.hidden = true;
      videoPreview.srcObject = null;
    }
    tuneIn_player.onpause = (event) => {
      setLive_btn_clicked(false);
    };
    tuneIn_player.onplay = (event) => {
      if (PlayerFrontOfficeReducer.is_web_rtc) {
        setLive_btn_clicked(true);
      } else {
        setLive_btn_clicked(false);
      }
    };
  }, [onAir, live_btn_clicked, curentObjSrc, PlayerFrontOfficeReducer]);
  useEffect(() => {
    dispatch(getMenus({ per_page: 20 }));
    dispatch(getWebsiteStyle());
  }, []);
  const [listArr1, setListArr1] = useState([]);
  const [listArr2, setListArr2] = useState([]);
  const filtered_Menu = MenuReducer?.filter((el) => el.status === 1);
  useEffect(() => {
    setListArr1(filtered_Menu.slice(0, filtered_Menu.length / 2));
    setListArr2(
      filtered_Menu.slice(filtered_Menu.length / 2, filtered_Menu.length)
    );
  }, [MenuReducer]);

  //Janus to listeners
  var janus_listeners = null;
  var sfutest = null;
  var opaqueId = "videoroomtest-" + Janus.randomString(12);
  var feeds = [],
    feedStreams = {};
  var mypvtid = null;
  var studio_id = null;

  const createListenerRoom = () => {
    Janus.init({
      debug: false,
      dependencies: Janus.useDefaultDependencies({ adapter: adapter }),
      callback: () => {
        janus_listeners = new Janus({
          server: REACT_APP_JANUS_SERVER,
          success: function () {
            janus_listeners.attach({
              plugin: "janus.plugin.videoroom",
              opaqueId: opaqueId,
              success: function (pluginHandle) {
                sfutest = pluginHandle;
                Janus.log(
                  "Plugin attached! (" +
                    sfutest.getPlugin() +
                    ", id=" +
                    sfutest.getId() +
                    ")"
                );
                Janus.log("  -- This is a publisher/manager");
                let transaction = Janus.randomString(12);
                let register = {
                  request: "join",
                  room: parseInt(radio_id),
                  ptype: "publisher",
                  display: "studio",
                  transaction: transaction,
                };
                sfutest.send({ message: register });
              },
              error: function (error) {
                Janus.error("  -- Error attaching plugin...", error);
              },
              onmessage: function (msg, jsep) {
                Janus.debug(" ::: Got a message (publisher) :::", msg);
                let event = msg["videoroom"];
                Janus.debug("Event: " + event);
                if (event) {
                  if (event === "joined") {
                    // Publisher/manager created, negotiate WebRTC and attach to existing feeds, if any
                    mypvtid = msg["private_id"];
                    // Any new feed to attach to?
                    if (msg["publishers"]) {
                      let list = msg["publishers"];
                      Janus.debug(
                        "Got a list of available publishers/feeds:",
                        list
                      );
                      for (let f in list) {
                        if (list[f]["dummy"]) continue;
                        let id = list[f]["id"];
                        let streams = list[f]["streams"];
                        let display = list[f]["display"];
                        studio_id = id;
                        for (let i in streams) {
                          let stream = streams[i];
                          stream["id"] = id;
                          stream["display"] = display;
                        }
                        feedStreams[id] = streams;
                        Janus.debug(
                          "  >> [" + id + "] " + display + ":",
                          streams
                        );
                        newRemoteFeed(id, display, streams);
                      }
                    }
                  } else if (event === "event") {
                    // Any info on our streams or a new feed to attach to?
                    if (msg["publishers"]) {
                      let list = msg["publishers"];
                      Janus.debug(
                        "Got a list of available publishers/feeds:",
                        list
                      );
                      for (let f in list) {
                        if (list[f]["dummy"]) continue;
                        let id = list[f]["id"];
                        let display = list[f]["display"];
                        let streams = list[f]["streams"];
                        studio_id = id;
                        for (let i in streams) {
                          let stream = streams[i];
                          stream["id"] = id;
                          stream["display"] = display;
                        }
                        feedStreams[id] = streams;
                        Janus.debug(
                          "  >> [" + id + "] " + display + ":",
                          streams
                        );
                        newRemoteFeed(id, display, streams);
                      }
                    } else if (msg["leaving"]) {
                      // One of the publishers has gone away?
                      let leaving = msg["leaving"];
                      if (msg["leaving"] === studio_id) {
                        let transaction = Janus.randomString(12);
                        let register = {
                          request: "leave",
                          room: parseInt(radio_id),
                          transaction: transaction,
                        };
                        sfutest.send({ message: register });
                      }
                      Janus.log("Publisher left: " + leaving);
                      let remoteFeed = null;
                      for (let i = 1; i < 6; i++) {
                        if (feeds[i] && feeds[i].rfid == leaving) {
                          remoteFeed = feeds[i];
                          break;
                        }
                      }
                      if (remoteFeed) {
                        Janus.debug(
                          "Feed " +
                            remoteFeed.rfid +
                            " (" +
                            remoteFeed.rfdisplay +
                            ") has left the room, detaching"
                        );
                        $("#video-preview").empty();
                        feeds[remoteFeed.rfindex] = null;
                        remoteFeed.detach();
                      }
                      delete feedStreams[leaving];
                    } else if (msg["error"]) {
                      if (msg["error_code"] === 426) {
                        // This is a "no such room" error: give a more meaningful description
                        console.log("Apparently room does not exist...");
                      } else {
                        console.log(msg["error"]);
                      }
                    }
                  }
                }
                if (jsep) {
                  Janus.debug("Handling SDP as well...", jsep);
                  sfutest.handleRemoteJsep({ jsep: jsep });
                  // Check if any of the media we wanted to publish has
                  // been rejected (e.g., wrong or unsupported codec)
                }
              },
              oncleanup: function () {
                Janus.log(
                  " ::: Got a cleanup notification: we are unpublished now :::"
                );
              },
            });
          },
          error: (err) => {
            console.log("errr", err);
          },
        });
      },
    });
  };
  function newRemoteFeed(id, display, streams) {
    // A new feed has been published, create a new plugin handle and attach to it as a subscriber
    let remoteFeed = null;
    if (!streams) streams = feedStreams[id];
    janus_listeners.attach({
      plugin: "janus.plugin.videoroom",
      opaqueId: opaqueId,
      success: function (pluginHandle) {
        remoteFeed = pluginHandle;
        remoteFeed.remoteTracks = {};
        remoteFeed.remoteVideos = 0;
        remoteFeed.simulcastStarted = false;
        remoteFeed.svcStarted = false;
        Janus.log(
          "Plugin attached! (" +
            remoteFeed.getPlugin() +
            ", id=" +
            remoteFeed.getId() +
            ")"
        );
        Janus.log("  -- This is a subscriber");
        // Prepare the streams to subscribe to, as an array: we have the list of
        // streams the feed is publishing, so we can choose what to pick or skip
        let subscription = [];
        for (let i in streams) {
          let stream = streams[i];
          // If the publisher is VP8/VP9 and this is an older Safari, let's avoid video
          if (
            stream.type === "video" &&
            Janus.webRTCAdapter.browserDetails.browser === "safari" &&
            (stream.codec === "vp9" ||
              (stream.codec === "vp8" && !Janus.safariVp8))
          ) {
            console.log(
              "Publisher is using " +
                stream.codec.toUpperCase +
                ", but Safari doesn't support it: disabling video stream #" +
                stream.mindex
            );
            continue;
          }
          subscription.push({
            feed: stream.id, // This is mandatory
            mid: stream.mid, // This is optional (all streams, if missing)
          });
          // FIXME Right now, this is always the same feed: in the future, it won't
          remoteFeed.rfid = stream.id;
          remoteFeed.rfdisplay = display;
        }
        // We wait for the plugin to send us an offer
        let transaction = Janus.randomString(12);
        let subscribe = {
          request: "join",
          room: parseInt(radio_id),
          ptype: "subscriber",
          streams: subscription,
          transaction: transaction,
          use_msid: false,
          private_id: mypvtid,
        };
        remoteFeed.send({ message: subscribe });
      },
      error: function (error) {
        Janus.error("  -- Error attaching plugin...", error);
        console.log("Error attaching plugin... " + error);
      },
      slowLink: function (uplink, lost, mid) {
        Janus.warn(
          "Janus reports problems " +
            (uplink ? "sending" : "receiving") +
            " packets on mid " +
            mid +
            " (" +
            lost +
            " lost packets)"
        );
      },
      onmessage: function (msg, jsep) {
        Janus.debug(" ::: Got a message (subscriber) :::", msg);
        let event = msg["videoroom"];
        Janus.debug("Event: " + event);
        if (msg["error"]) {
          console.log(msg["error"]);
        } else if (event) {
          if (event === "attached") {
            // Subscriber created and attached
            for (let i = 1; i < 6; i++) {
              if (!feeds[i]) {
                feeds[i] = remoteFeed;
                remoteFeed.rfindex = i;
                break;
              }
            }
            Janus.log("Successfully attached to feed in room " + msg["room"]);
          }
        }
        if (jsep) {
          Janus.debug("Handling SDP as well...", jsep);
          let stereo = jsep.sdp.indexOf("stereo=1") !== -1;
          // Answer and attach
          remoteFeed.createAnswer({
            jsep: jsep,
            // We only specify data channels here, as this way in
            // case they were offered we'll enable them. Since we
            // don't mention audio or video tracks, we autoaccept them
            // as recvonly (since we won't capture anything ourselves)
            tracks: [{ type: "data" }],
            customizeSdp: function (jsep) {
              if (stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                // Make sure that our offer contains stereo too
                jsep.sdp = jsep.sdp.replace(
                  "useinbandfec=1",
                  "useinbandfec=1;stereo=1"
                );
              }
            },
            success: function (jsep) {
              Janus.debug("Got SDP!", jsep);
              let body = { request: "start", room: parseInt(radio_id) };
              remoteFeed.send({ message: body, jsep: jsep });
              const rpElement = document.getElementById(`rp${id}`);
              rpElement?.querySelector(".fallback-spinner")?.remove();
            },
            error: function (error) {
              Janus.error("WebRTC error:", error);
              console.log("WebRTC error... " + error.message);
            },
          });
        }
      },
      onremotetrack: function (track, mid, on, metadata) {
        Janus.debug(
          "Remote feed #" +
            remoteFeed.rfindex +
            ", remote track (mid=" +
            mid +
            ") " +
            (on ? "added" : "removed") +
            (metadata ? " (" + metadata.reason + ") " : "") +
            ":",
          track
        );
        Janus.debug("metadatametadata", metadata);
        if (!on) {
          // Track removed, get rid of the stream and the rendering
          if (track.kind === "video") {
            remoteFeed.remoteVideos--;
            if (remoteFeed.remoteVideos === 0) {
              // No video, at least for now: show a placeholder
              console.log("remoteFeed.remoteVideos === 0");
            }
          }
          delete remoteFeed.remoteTracks[mid];
          return;
        }
        if (track.kind === "audio") {
          // New audio track: create a stream out of it, and use a hidden <audio> element
          let stream = new MediaStream([track]);
          remoteFeed.remoteTracks[mid] = stream;
          Janus.log("Created remote audio stream:", stream);
          setCurentObjSrc(stream);
          if (remoteFeed.remoteVideos === 0) {
            // No video, at least for now: show a placeholder
            console.log("remoteFeed.remoteVideos === 0");
          }
        } else {
          // New video track: create a stream out of it
          remoteFeed.remoteVideos++;
          let stream = new MediaStream([track]);
          remoteFeed.remoteTracks[mid] = stream;
          Janus.log("Created remote video stream:", stream);
          setCurentObjSrc(stream);
        }
      },
      oncleanup: function () {
        Janus.log(
          " ::: Got a cleanup notification (remote feed " + id + ") :::"
        );
        remoteFeed.simulcastStarted = false;
        remoteFeed.remoteTracks = {};
        remoteFeed.remoteVideos = 0;
      },
    });
  }
  //Janus to listeners
  useEffect(() => {
    onAir ? createListenerRoom() : setCurentObjSrc();
  }, [onAir]);

  return (
    <div>
      <div className="back2top-btn">
        <i onClick={goTop} className="fa fa-arrow-up"></i>
      </div>

      {onAir ? <GroupChat /> : null}
      <header className="header-part">
        <div className="header-bg">
          <div className="container__">
            <Row>
              <Col lg={6}>
                <div className="d-flex align-items-center">
                  <Link
                    onClick={() => {
                      toggleActive("/");
                    }}
                    to="/"
                  >
                    <img
                      src={
                        SettingsReducer?.style_logo
                          ? SettingsReducer.style_logo
                          : "https://dieselpunkcore.com/wp-content/uploads/2014/06/logo-placeholder.png"
                      }
                      alt="logo"
                      style={{ width: "51px", height: "51px" }}
                    />
                  </Link>
                  <div className="my-auto" style={{ marginLeft: "5px" }}>
                    <h6
                      style={{ color: `${SettingsReducer?.style_color1}` }}
                      className="fw-bolder mb-0"
                    >
                      {t(SettingsReducer?.text_1)}
                    </h6>
                    <CardText className="font-small-3 mb-0">
                      <span
                        style={{ color: `${SettingsReducer?.style_color2}` }}
                      >
                        {t(SettingsReducer?.text_2)}
                      </span>
                    </CardText>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                {thisisAuth == "true" ? (
                  <div className="header-btn">
                    <Link className="btn btn-outline" to="/admin/dashboard">
                      <span>{t("Dashboard")}</span>
                    </Link>
                  </div>
                ) : (
                  <div className="header-btn">
                    <Link className="btn btn-outline" to="/admin/login">
                      <span>{t("Login")}</span>
                    </Link>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </header>
      <WidgetsFloatingMenu />
      <nav className="Ushnos navbar-part">
        <div className="navbar-bg">
          <div className="navbar-content">
            <Link
              onClick={() => {
                toggleActive("/");
              }}
              className="navbar-logo"
              to="/"
            >
              <img
                src={SettingsReducer?.style_logo && SettingsReducer?.style_logo}
                alt="logo"
                style={{ width: "51px", height: "51px" }}
              />
              <h6 style={{ color: `${SettingsReducer?.style_color1}` }}>
                {t(SettingsReducer?.text_1)}
              </h6>
              <h6 style={{ color: `${SettingsReducer?.style_color2}` }}>
                {t(SettingsReducer?.text_2)}
              </h6>
            </Link>
            <button
              className="navbar-toggle"
              onClick={() => {
                setToggleThreeBars(true);
              }}
            >
              <i className="fa fa-bars"></i>
            </button>

            <div
              className={
                toggleThreeBars ? "navbar-overlay active" : "navbar-overlay"
              }
            >
              <div className="navbar-slide">
                <div className="slide-head">
                  <div>
                    <Link
                      onClick={() => {
                        toggleActive("/");
                      }}
                      to="/"
                    >
                      <img
                        src={SettingsReducer?.style_logo && SettingsReducer?.style_logo}
                        alt="logo"
                        style={{ width: "51px", height: "51px" }}
                      />
                    </Link>
                    <button
                      className="cencel"
                      onClick={() => {
                        setToggleThreeBars(false);
                      }}
                    >
                      <i className="fa fa-times"></i>
                    </button>
                    <div className="my-auto">
                      <h6
                        style={{ color: `${SettingsReducer?.style_color1}` }}
                        className="fw-bolder mb-0"
                      >
                        {t(SettingsReducer?.text_1)}
                      </h6>
                      <CardText className="font-small-3 mb-0">
                        <span
                          style={{
                            color: `${SettingsReducer?.style_color2}`,
                          }}
                        >
                          {t(SettingsReducer?.text_2)}
                        </span>
                      </CardText>
                    </div>
                  </div>
                </div>

                <ul className="navbar-list">
                  {listArr1?.map((item, i) => {
                    return item.children.length > 0 ? (
                      <UncontrolledButtonDropdown
                        key={i}
                        className={
                          active.includes(`${item.link}`)
                            ? "me-1 cursor-pointer navbar-item active"
                            : "me-1 cursor-pointer"
                        }
                      >
                        <DropdownToggle
                          tag="span"
                          className="navbar-link"
                          color="none"
                        >
                          <span>
                            <i className={`${item.icon}`}></i>
                            {t(item.title)}
                          </span>
                          <small className="fa fa-chevron-down"></small>
                        </DropdownToggle>
                        <DropdownMenu center="true">
                          {item.children.map((e, i) => {
                            return (
                              <DropdownItem
                                onClick={() => {
                                  toggleActive(`${e.link}`);
                                }}
                                key={i}
                                tag={Link}
                                to={`${e.link}`}
                                className={
                                  active.includes(`${e.link}`)
                                    ? "dropdown-link active"
                                    : "dropdown-link"
                                }
                              >
                                {t(e.title)}
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    ) : (
                      <li
                        key={i}
                        className={
                          active === `${item.link}`
                            ? "navbar-item active"
                            : "navbar-item "
                        }
                      >
                        <Link
                          onClick={() => {
                            toggleActive(`${item.link}`);
                          }}
                          className="navbar-link"
                          to={`${item.link}`}
                        >
                          <span>
                            <i className={`${item.icon}`}></i>
                            {t(item.title)}
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                  <div className="timer-audience-navbar">
                    <span>
                      <SiAirplayaudio
                        className="clignoteAudience"
                        size={18}
                        style={{ marginTop: "-3px", marginRight: "3px" }}
                      />
                      {window.innerWidth > 564
                        ? `${t("Number of listeners")}: ${listeners}`
                        : listeners}
                    </span>
                  </div>
                  <div className="navbar-player">
                    <div className="player" id="player-opcaity">
                      <button
                        className={classNames("player-btn", {
                          open: onAir,
                        })}
                        id="play-pause-button"
                        onClick={() => {
                          !isloadind && playerPause ? playAudio() : stopAudio();
                        }}
                      >
                        {isloadind ? (
                          <div className="loading-centered">
                            <Spinner color="light" />
                          </div>
                        ) : playerPause ? (
                          <i className="fa fa-play"></i>
                        ) : (
                          <i className="fa fa-stop"></i>
                        )}
                      </button>
                    </div>
                  </div>

                  {listArr2.map((item, i) => {
                    return item.children.length > 0 ? (
                      <UncontrolledButtonDropdown
                        key={i}
                        className={
                          active.includes(`${item.link}`)
                            ? "me-1 cursor-pointer navbar-item active"
                            : "me-1 cursor-pointer"
                        }
                      >
                        <DropdownToggle
                          tag="span"
                          className="navbar-link"
                          color="none"
                        >
                          <span>
                            <i className={`${item.icon}`}></i>
                            {t(item.title)}
                          </span>
                          <small className="fa fa-chevron-down"></small>
                        </DropdownToggle>
                        <DropdownMenu center="true">
                          {item.children.map((e, i) => {
                            return (
                              <DropdownItem
                                onClick={() => {
                                  toggleActive(`${e.link}`);
                                }}
                                key={i}
                                tag={Link}
                                to={`${e.link}`}
                                className={
                                  active.includes(`${e.link}`)
                                    ? "dropdown-link active"
                                    : "dropdown-link"
                                }
                              >
                                {t(e.title)}
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    ) : (
                      <li
                        key={i}
                        className={
                          active === `${item.link}`
                            ? "navbar-item active"
                            : "navbar-item "
                        }
                      >
                        <Link
                          onClick={() => {
                            toggleActive(`${item.link}`);
                          }}
                          className="navbar-link"
                          to={`${item.link}`}
                        >
                          <span>
                            <i className={`${item.icon}`}></i>
                            {t(item.title)}
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>

                <div className="lang-frontOffice list-unstyled me-1">
                  <IntlDropdown />
                </div>
                <div className="navbar-btn">
                  {thisisAuth == "true" ? (
                    <Link className="btn btn-outline" to="/admin/dashboard">
                      <i className="fa fa-handshake"></i>
                      <span>{t("Dashboard")}</span>
                    </Link>
                  ) : (
                    <Link className="btn btn-outline" to="/admin/login">
                      <i className="fa fa-handshake"></i>
                      <span>{t("Login")}</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className="bottom-player">
        <div className="timer-audience-navbar-bottom">
          <span>
            <SiAirplayaudio
              className="clignoteAudience"
              size={18}
              style={{ marginTop: "-3px", marginRight: "3px" }}
            />
            {window.innerWidth > 564
              ? `${t("Number of listeners")}: ${listeners}`
              : listeners}
          </span>
        </div>
        <div className="player">
          <button
            className={classNames("player-btn", {
              open: onAir,
            })}
            id="play-pause-button"
            onClick={() => {
              !isloadind && playerPause ? playAudio() : stopAudio();
            }}
          >
            {isloadind ? (
              <div className="loading-centered">
                <div className="loading-centered">
                  <Spinner color="light" />
                </div>
              </div>
            ) : playerPause ? (
              <i className="fa fa-play"></i>
            ) : (
              <i className="fa fa-stop"></i>
            )}
          </button>
        </div>

        <div className="timer-audience-navbar1-bottom">
          <span>
            <Clock
              size={18}
              style={{ marginTop: "-3px", marginRight: "3px" }}
            />
            {timeNow.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
